import { getDocCMSContractDocument } from 'app/modules/cms/service/cmsService';
import { contractDocumentsDataSelector } from 'app/modules/cms/service/store/selectors';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { getNavItemsMobile } from 'app/modules/rules/service/store/selectors';
import { IRootState } from 'app/shared/reducers';
import PrismicDom from 'prismic-dom';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './style.scss';

export const ContractDocumentsPage = props => {
  // const docName="legal_notice"


  const location: any = useLocation();
  const dN: any = location?.state?.documentName;
  const defaultD: boolean = location?.state?.default;

  const contractDocumentsData: any = useSelector(contractDocumentsDataSelector(dN));
  const drulesConfig = useSelector(getNavItemsMobile(RulesKeys.GET_CONF));
  const urlProd = drulesConfig?.settings?.urlProd;
  const device = drulesConfig?.settings?.deviceType;

  const dispatch = useDispatch();


  useEffect(() => {
    if (dN) {
      dispatch(getDocCMSContractDocument(defaultD, dN));
    }
  }, [dN]);
  return contractDocumentsData ? (
    <div style={(device === "MOBILE") ? { height: `calc(100vh - 110px)`, overflowY: 'scroll' } : {}} className="p-3">
      <div dangerouslySetInnerHTML={{ __html: PrismicDom.RichText.asHtml(contractDocumentsData?.title) }}></div>
      <div dangerouslySetInnerHTML={{ __html: PrismicDom.RichText.asHtml(contractDocumentsData?.content)?.replace('${url_principale}', urlProd) }}></div>
    </div>
  ) : (
    <></>
  );
};
